export const modern = [
  {
    number: 'MB097',
    hasModel: false
  },
  {
    number: 'MB099',
    hasModel: false
  },
  {
    number: 'MB100',
    hasModel: false
  },
  {
    number: 'MB101',
    hasModel: false
  },
  {
    number: 'MB102',
    hasModel: false
  },
  {
    number: 'MB103',
    hasModel: false
  },
  {
    number: 'MB104',
    hasModel: false
  },
  {
    number: 'MB105',
    hasModel: false
  },
  {
    number: 'MB106',
    hasModel: false
  },
  {
    number: 'MB107',
    hasModel: false
  },
  {
    number: 'MB108',
    hasModel: false
  },
  {
    number: 'MB109',
    hasModel: false
  },
  {
    number: 'MB110',
    hasModel: false
  },
  {
    number: 'MB111',
    hasModel: false
  },
  {
    number: 'MB112',
    hasModel: false
  },
  {
    number: 'MB113',
    hasModel: false
  },
  {
    number: 'MB114',
    hasModel: false
  },
  {
    number: 'MB115',
    hasModel: false
  },
  {
    number: 'MB116',
    hasModel: false
  },
  {
    number: 'MB117',
    hasModel: false
  },
  {
    number: 'MB118',
    hasModel: false
  },
  {
    number: 'MB119',
    hasModel: false
  },
  {
    number: 'MB120',
    hasModel: false
  },
  {
    number: 'MB121',
    hasModel: false
  },
  {
    number: 'MB122',
    hasModel: false
  },
  {
    number: 'MB123',
    hasModel: false
  },
  {
    number: 'MB124',
    hasModel: false
  },
  {
    number: 'MB125',
    hasModel: false
  },
  {
    number: 'MB126',
    hasModel: false
  },
  {
    number: 'MB127',
    hasModel: false
  },
  {
    number: 'MB128',
    hasModel: false
  },
  {
    number: 'MB129',
    hasModel: false
  },
  {
    number: 'MB130',
    hasModel: false
  },
  {
    number: 'MB131',
    hasModel: false
  },
  {
    number: 'MB132',
    hasModel: false
  },
  {
    number: 'MB133',
    hasModel: false
  },
  {
    number: 'MB134',
    hasModel: false
  },
  {
    number: 'MB135',
    hasModel: false
  },
  {
    number: 'MB136',
    hasModel: false
  },
  {
    number: 'MB137',
    hasModel: false
  },
  {
    number: 'MB138',
    hasModel: false
  },
  {
    number: 'MB139',
    hasModel: false
  },
  {
    number: 'MB140',
    hasModel: false
  },
  {
    number: 'MB141',
    hasModel: false
  },
  {
    number: 'MB142',
    hasModel: false
  },
  {
    number: 'MB143',
    hasModel: false
  },
]